

















































import { computed, defineComponent } from "@vue/composition-api";
import { intervalToDuration } from "date-fns";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { Appointment, AppointmentStatus } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import { AppointmentTypeKind } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentTypeProvider";
import { formatMoneyString } from "@scrile/tools/dist/lib/MoneyHelpers";
import { $t } from "@/lib/i18nHelpers";
import { getMainCurrencyCode } from "@/lib/moneyHelpers";
import { formatDate } from "@/lib/time";
import { getProfileUrl } from "@/lib/urlHelpers";
import { BaseMenuItem } from "@/types";
import BaseAvatar from "@/components/BaseAvatar";
import BaseList from "@/components/BaseList";
import BaseListItem from "@/components/BaseList/BaseListItem.vue";
import BaseMenu from "@/components/BaseMenu";
import ScreenNamePrinter from "@/components/ScreenNamePrinter";
import TextClamp from "@/components/TextClamp";

export interface MenuItem extends BaseMenuItem {
  click: () => void;
}

const appointmentTypeNames = {
  [AppointmentTypeKind.TOUR_GUIDE]: $t("Offline meeting"),
  [AppointmentTypeKind.MESSAGING]: $t("Messaging"),
  [AppointmentTypeKind.VIDEO_CALLS]: $t("Video call"),
  [AppointmentTypeKind.AUDIO_CALLS]: $t("Audio call"),
};

export default defineComponent({
  name: "AppointmentsItemView",
  components: { ScreenNamePrinter, TextClamp, BaseListItem, BaseList, BaseAvatar, BaseMenu },
  props: {
    item: { type: Object as () => Appointment, required: true },
    menuItems: { type: Array as () => MenuItem[], default: () => [] },
    authUserId: { type: String, required: true },
  },
  setup(props) {
    const date = computed(() =>
      formatDate(new Date(props.item.startTime), {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })
    );

    const opponent = computed<UserPublicData>(() =>
      props.authUserId === props.item.consumerId ? props.item.provider : props.item.consumer
    );

    const price = computed(() => formatMoneyString(props.item.amount, { currencyCode: getMainCurrencyCode() }));
    const reason = computed(() =>
      [AppointmentStatus.REJECTED, AppointmentStatus.CANCELLED].includes(props.item.status)
        ? props.item.lastStatusChange?.message ?? ""
        : ""
    );

    const duration = computed(() => {
      const { hours: h = 0, minutes: m = 0 } = intervalToDuration({
        start: new Date(props.item.startTime),
        end: new Date(props.item.endTime),
      });
      return `${h > 0 ? h + "h" : ""} ${m > 0 ? m + "m" : ""}`;
    });

    const onClickHandler = (name: string) => {
      const menuItem = props.menuItems?.find(i => i.name === name);
      menuItem && menuItem.click && menuItem.click();
    };

    return {
      AppointmentTypeKind,
      date,
      opponent,
      appointmentTypeNames,
      price,
      duration,
      AppointmentStatus,
      reason,
      onClickHandler,
      getProfileUrl,
    };
  },
});
